import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";

const ConfirmDeleteModal = ({
  onAccept,
  onReject,
  audio,
  challenge,
  contest,
  faq,
  karaoke,
  dance,
  words,
  rap,
  battle,
  theme,
  poll,
  bulkCount,
}) => {
  const getContent = () => {
    if (bulkCount && bulkCount > 1) {
      if (audio) return `Are you sure you want to delete ${bulkCount} audios?`;
      else if (challenge) return `Are you sure you want to delete ${bulkCount} challenges?`;
      else if (contest) return `Are you sure you want to delete ${bulkCount} contests?`;
      else return `Are you sure you want to delete ${bulkCount} items?`;
    }
    if (faq) return "Are you sure you want to delete this FAQ?";
    else if (challenge)
      return "Are you sure you want to delete this challenge?";
    else if (contest)
      return "Are you sure you want to delete this contest?";
    else if (theme)
      return "Are you sure you want to delete this theme?";
    else if (poll)
      return "Are you sure you want to delete this naming poll?";
    else if (audio) return "Are you sure you want to delete this audio?";
    else if (karaoke) return "Are you sure you want to delete this karaoke?";
    else if (dance) return "Are you sure you want to delete this dance track?";
    else if (rap) return "Are you sure you want to delete this Audio?";
    else if (battle) return "Are you sure you want to delete this Battle?";
    else if (words) return "Are you sure you want to delete selected words?";
    else return "Are you sure you want to delete this category?";
  };
  return (
    <Dialog
      sx={{
        zIndex: "9",
        "& .MuiDialog-container .MuiPaper-elevation": {
          borderRadius: "8px",
          width: "380px",
        },
      }}
      open={true}
      onClose={onReject}
    >
      <DialogTitle
        sx={{
          padding: "30px 16px 0",
          textAlign: "center",
          fontWeight: 700,
        }}
      >
        Confirm Deletion
      </DialogTitle>
      <DialogContent sx={{ padding: "0 16px 20px" }}>
        <Typography sx={{ textAlign: "center", color: "#666" }}>
          {getContent()}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: "0 16px 20px" }}>
        <Button
          onClick={onReject}
          sx={{
            border: "1px solid #888",
            color: "#888",
            borderRadius: "6px",
            fontSize: "14px",
            "&:hover": {
              backgroundColor: "#b9b9b9",
              color: "#222",
              borderColor: "#b9b9b9",
            },
          }}
        >
          No
        </Button>
        <Button
          onClick={onAccept}
          sx={{
            backgroundColor: "#142C5C",
            color: "#fff",
            borderColor: "#0f2247",
            "&:hover": {
              backgroundColor: "#0f2247",
            },
            borderRadius: "6px",
            fontSize: {
              xs: "12px",
              sm: "13px",
              md: "13px",
              lg: "14px",
              xl: "14px",
            },
            height: "40px",
          }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
